<script lang="ts">
  import { createEventDispatcher } from 'svelte'

  export let value: string

  const dispatch = createEventDispatcher()
</script>

<div class="html-text" on:click={() => dispatch('edit')}>{@html value}</div>

<style lang="scss">
  :global(.html-text *) {
    color: #37352F;
  }

  :global(.html-text li) {
    margin-bottom: 16px;
    line-height: 28px;
  }

  :global(.html-text em) {
    font-style: italic;
  }

  :global(.html-text h1, h2, h3, p) {
    margin: 0 !important;
    margin-bottom: 16px !important;
  }

  :global(.html-text ul, ol) {
    margin: 0;
  }

  :global(.html-text ol) {
    padding: 0 16px;
  }

  :global(.html-text ul) {
    padding: 0 24px;
  }

  :global(.html-text h1) {
    font-size: 40px;
    font-weight: 600;
    line-height: 52px;
  }

  :global(.html-text h2) {
    font-size: 30px;
    font-weight: 600;
    line-height: 39px;
  }

  :global(.html-text h3) {
    font-size: 20px;
    font-weight: 600;
    line-height: 29px;
  }

  :global(.html-text p) {
    font-size: 16px;
    line-height: 28px;
  }

  :global(.html-text a) {
    font-size: 16px;
    line-height: 28px;
    color: #2B50ED;
    text-decoration: none;
  }
</style>